import store from '@/store'
export default [
  {
    path: '/main-programs',
    name: 'main-program',
    meta: { requiresAuth: true },
    component: () => import('@/pages/main-program/index-v2.vue')
  },
  {
    path: '/main-programs/:id',
    name: 'main-program-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/main-program/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await store.dispatch('mainProgram/find', to.params.id)
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
